<template>
    <div class="base-alert" :class="`base-alert--${variant}`">
        <div>
            <InfoIcon color="currentColor" class="alert__icon" />
        </div>
        <div>
            <slot />
        </div>
        <slot name="alt" />
    </div>
</template>

<script>
import InfoIcon from '@/components/icons/InfoIcon'

export default {
    name: 'BaseAlert',
    components: {
        InfoIcon,
    },
    props: {
        variant: {
            type: String,
            default: 'primary',
            validator: value => {
                return ['danger', 'primary', 'success', 'warning'].includes(
                    value
                )
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.base-alert {
    padding: 16px;
    display: flex;
    gap: 16px;
    border-radius: 8px;
    background-color: $color-gray-light-new;
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;

    &__icon {
        width: 24px;
        height: 24px;
        color: $color-danger;
    }

    &--danger {
        background-color: rgba($color-danger, 0.1);
        color: $color-danger;
    }

    &--primary {
        background-color: rgba($color-pill-blue, 0.1);
        color: $color-pill-blue;
    }

    &--success {
        background-color: rgba($color-success, 0.1);
        color: $color-success;
    }

    &--warning {
        background-color: rgba($color-orange, 0.1);
        color: $color-orange;
    }
}
</style>
